import router from '../router';
import VueCookies from 'vue-cookies';
import toast from './toast';
import pinia from './pinia';
import type { Plugin } from 'vue';

interface CustomPlugin {
    plugin: Plugin;
    options: unknown[];
}

const plugins: (Plugin | CustomPlugin)[] = [router, VueCookies, toast, pinia];

export default plugins.map((plugin) => {
    return 'options' in plugin && Array.isArray(plugin.options)
        ? {
            plugin: plugin.plugin,
            options: plugin.options,
        }
        : { plugin: plugin as Plugin, options: [] };
});
